import Link from 'next/link'
import { useUsedCarsData } from '../../hooks/use-used-cars-data/use-used-cars-data'

export const UsedCarsDataTempComponent = () => {
  const {
    isValidating,
    isLoading,
    usedCarsApiError,
    searchResults,
    searchParams,
    setPageNumber,
    getUrlForPageNumber,
  } = useUsedCarsData()
  const currentPageNumber = searchParams?.pageNumber ?? 1
  const handlePageButtonClicked = (direction: 'prev' | 'next') => () => {
    const pageOffset = direction === 'next' ? 1 : -1
    setPageNumber(Math.max(1, currentPageNumber + pageOffset))
  }

  return (
    <div>
      useUsedCarsData hook testing - dev only
      <span>
        <button onClick={handlePageButtonClicked('prev')}>Previous page</button>
        {currentPageNumber}
        <button onClick={handlePageButtonClicked('next')}>Next page</button>
      </span>
      <span>
        searchParams: <pre>{JSON.stringify(searchParams, null, 2)}</pre>
      </span>
      <span>isValidating: {isValidating ? 'true' : 'false'}</span>
      <span>isLoading: {isLoading ? 'true' : 'false'}</span>
      <span>
        usedCarsApiError: <pre>{usedCarsApiError}</pre>
      </span>
      <span>
        Pages:
        <Link href={getUrlForPageNumber(1)}>1</Link>
        <Link href={getUrlForPageNumber(2)}>2</Link>
        <Link href={getUrlForPageNumber(3)}>3</Link>
      </span>
      <span>
        searchResults: <pre>{JSON.stringify(searchResults, null, 2)}</pre>
      </span>
    </div>
  )
}
